export default __webpack_public_path__ + "static/media/soesvinget-property-19.7ee10165.jpg";